import { useContext, createContext } from 'react';

import { ChartLegendOrientation } from '../../../../types/legend.js';

interface RangeLegendOrientationContextProps {
  orientation: ChartLegendOrientation;
}

export const RangeLegendOrientationContext =
  createContext<RangeLegendOrientationContextProps>(
    {} as RangeLegendOrientationContextProps,
  );

export const useOrientation = () => useContext(RangeLegendOrientationContext);
